<template>
  <div>
    <div class="col-md-12 word">
      <div class="col-md-2">{{ word.keyword }}</div>
      <div class="col-md-10">
        {{ word.meaning }}
        <table class="table_icon">
          <tr>
            <td class="title">
              <p>ยุทธศาสตร์ชาติ</p>
            </td>
            <td>
              <div
                v-for="(item, index) in strategy"
                v-bind:key="item.title"
                v-b-tooltip.hover
                class="round_button"
                :class="{ active: index + 1 == word.sappear }"
                :title="item.title"
                :data-toggle="'tooltip'"
              >
                <svg :class="item.icon" fill="white" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="title">
              <p>แผนแม่บทภายใต้ยุทธศาสตร์ชาติ</p>
            </td>
            <td>
              <div
                v-for="(item, index) in masterplan"
                v-bind:key="item.title"
                v-b-tooltip.hover
                class="round_button"
                :class="{ active: index + 1 == word.mappear }"
                :title="item.title"
                :data-toggle="'tooltip'"
              >
                <svg :class="item.icon" fill="white" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="title">
              <p>แผนการปฏิรูปประเทศ</p>
            </td>
            <td>
              <div
                v-for="(item, index) in reform"
                v-bind:key="item.title"
                v-b-tooltip.hover
                class="round_button"
                :class="{ active: index + 1 == word.rappear }"
                :title="item.title"
                :data-toggle="'tooltip'"
              >
                <svg :class="item.icon" fill="white" />
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["word"],
  data: () => ({
    strategy: [
      {
        title: "ด้านความมั่นคง",
        icon: "icon strategy-flag"
      },
      {
        title: "ด้านการสร้างความสามารถในการแข่งขัน",
        icon: "icon strategy-stats"
      },
      {
        title: "ด้านการพัฒนาและเสริมสร้างศักยภาพทรัพยากรมนุษย์",
        icon: "icon strategy-education"
      },
      {
        title: "ด้านการสร้างโอกาสและความเสมอภาคทางสังคม",
        icon: "icon strategy-user"
      },
      {
        title: "ด้านการสร้างการเติบโตบนคุณภาพชีวิตที่เป็นมิตรต่อสิ่งแวดล้อม",
        icon: "icon strategy-government"
      },
      {
        title: "ด้านการปรับสมดุลและพัฒนาระบบการบริหารจัดการภาครัฐ",
        icon: "icon strategy-government"
      }
    ],
    masterplan: [
      {
        title: "ประเด็น ความมั่นคง",
        icon: "icon insurance"
      },
      {
        title: "ประเด็น การต่างประเทศ",
        icon: "icon cultures"
      },
      {
        title: "ประเด็น การพัฒนาการเกษตร",
        icon: "icon up-arrow"
      },
      {
        title: "ประเด็น อุตสาหกรรมและบริการแห่งอนาคต",
        icon: "icon innovation"
      },
      {
        title: "ประเด็น สร้างความหลากหลายด้านการท่องเที่ยว",
        icon: "icon world"
      },
      {
        title: "ประเด็น การพัฒนาพื้นที่และเมืองน่าอยู่อัจฉริยะ",
        icon: "icon cityscape"
      },
      {
        title: "ประเด็น โครงสร้างพื้นฐาน ระบบโลจิสติกส์ และดิจิทัล",
        icon: "icon travel"
      },
      {
        title:
          "ประเด็น พัฒนาเศรษฐกิจบนพื้นฐานผู้ประกอบการยุคใหม่และวิสาหกิจขนาดกลางและขนาดย่อม",
        icon: "icon employee"
      },
      {
        title: "ประเด็น เขตพัฒนาพิเศษภาคตะวันออก",
        icon: "icon factory"
      },
      {
        title: "ประเด็น การปรับเปลี่ยนค่านิยมและวัฒนธรรม",
        icon: "icon pray"
      },
      {
        title: "ประเด็น การพัฒนาศักยภาพคนตลอดช่วงชีวิต",
        icon: "icon leadership"
      },
      {
        title: "ประเด็น การพัฒนาการเรียนรู้",
        icon: "icon think"
      },
      {
        title: "ประเด็น การเสริมสร้างให้คนไทยมีสุขภาวะที่ดี",
        icon: "icon happiness"
      },
      {
        title: "ประเด็น ศักยภาพการกีฬา",
        icon: "icon fast"
      },
      {
        title: "ประเด็น การเสริมสร้างพลังทางสังคม",
        icon: "icon teamwork"
      },
      {
        title: "ประเด็น การพัฒนาความเสมอภาคและส่งเสริมเศรษฐกิจฐานราก",
        icon: "icon equal"
      },
      {
        title: "ประเด็น การสร้างหลักประกันทางสังคม",
        icon: "icon ecology"
      },
      {
        title: "ประเด็น การสร้างการเติบโตอย่างยั่งยืน",
        icon: "icon planting"
      },
      {
        title: "ประเด็น การบริหารจัดการน้ำทั้งระบบ",
        icon: "icon wave"
      },
      {
        title: "ประเด็น การพัฒนาบริการประชาชนและการพัฒนาประสิทธิภาพภาครัฐ",
        icon: "icon government"
      },
      {
        title: "ประเด็น การต่อต้านการทุจริตและประพฤติมิชอบ",
        icon: "icon corruption"
      },
      {
        title: "ประเด็น การพัฒนากฏหมายและกระบวนการยุติธรรม",
        icon: "icon auction"
      },
      {
        title: "ประเด็น การวิจัยและพัฒนานวัตกรรม",
        icon: "icon innovation1"
      }
    ],
    reform: [
      {
        title: "ด้านการเมือง",
        icon: "icon reform-flag"
      },
      {
        title: "ด้านการบริหารราชการแผ่นดิน",
        icon: "icon reform-government"
      },
      {
        title: "ด้านกฎหมาย",
        icon: "icon reform-book"
      },
      {
        title: "ด้านกระบวนการยุติธรรม",
        icon: "icon reform-balance"
      },
      {
        title: "ด้านเศรษฐกิจ",
        icon: "icon reform-banknotes"
      },
      {
        title: "ด้านทรัพยากรธรรมชาติและสิ่งแวดล้อม",
        icon: "icon reform-forest"
      },
      {
        title: "ด้านสาธารณสุข",
        icon: "icon reform-ambulance"
      },
      {
        title: "ด้านสื่อสารมวลชน เทคโนโลยีสารสนเทศ",
        icon: "icon reform-satellite"
      },
      {
        title: "ด้านสังคม",
        icon: "icon reform-family"
      },
      {
        title: "ด้านพลังงาน",
        icon: "icon reform-gas"
      },
      {
        title: "ด้านการป้องกันและปราบปรามการทุจริตและประพฤติมิชอบ",
        icon: "icon reform-eye"
      }
    ]
  })
};
</script>
